import { render, staticRenderFns } from "./approval-request.vue?vue&type=template&id=6bd51a63&scoped=true&lang=pug&"
import script from "./approval-request.vue?vue&type=script&lang=js&"
export * from "./approval-request.vue?vue&type=script&lang=js&"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=6bd51a63&lang=scss&scoped=true&"
import style1 from "./approval-request.vue?vue&type=style&index=1&id=6bd51a63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd51a63",
  null
  
)

export default component.exports